// extracted by mini-css-extract-plugin
module.exports = {"backdrop":"Drawer-styles-module--backdrop--H9YaM layout-module--cover--2-RiG"};